import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  flex-wrap: nowrap;
  padding: 0px 0;

  .classification-legend {
    table {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #5e5e5e;

      tr td {
        height: 28px;
        max-width: 180px;
        padding: 6px 10px 6px 0px;
        word-wrap: break-word;
      }

      .simbol-legend {
        vertical-align: top;
        padding-top: 6px;
      }
    }
  }

  .static-legend {
    svg {
      vertical-align: middle;
    }

    span {
      vertical-align: middle;
      padding-top: 4px;
      padding-left: 10px;
      color: #5e6366;
    }
  }

  .footer {
    margin-top: 20px;
    bottom: 0;
    width: 100%;
    .button-area {
      width: 200px;
      padding: 10px;
      margin: 0 auto 20px;
    }
  }

  /**
  * Estilização do Formulário Output de Impressao
  */
  form {
    padding-left: 40px;
    padding-right: 24px;
    overflow: auto;
  }

  .overflow {
    width: 100%;
  }

  hr {
    border: 1px solid #e6e6e6;
    height: 0px;
    margin-right: 35px;
  }

  h2,
  .checkbox label {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
    position: relative;
    top: 10px;
  }

  label {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5e5e5e;
  }

  .marginLabel {
    width: 100%;
    padding-left: 10px;
  }

  .displayPrinter {
    display: flex;
  }

  .selectPrinter {
    width: 201.73px;
    height: 40px;

    border: 0.5px solid rgba(0, 0, 0, 0.33);
    border-radius: 3px;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    color: #ababab;
  }

  select {
    margin-top: 4.3px;
    padding: 0px 12px;
    background: #ffffff;
    font-family: 'Roboto';
  }

  .props {
    position: relative;
    top: 46px;
    left: 20px;
  }

  .map-side {
    width: 100%;
    border-left: 1px solid #e5e5e5;

    .container-map {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: center;

      .vertical-grid {
        height: 600px;
        margin-right: 5px;
      }

      #leaflet-map-ajust-print {
        width: ${({ widthMap }) => (widthMap ? widthMap + 'px' : '680px')};
        height: ${({ heightMap }) => (heightMap ? heightMap + 'px' : '640px')};
      }

      .bottomRight {
        position: absolute;
        right: ${({ gridCheck }) => (gridCheck ? '44px' : '32px')};
        bottom: ${({ gridCheck }) => (gridCheck ? '94px' : '54px')};
        z-index: 1400;
        display: flex;
        justify-content: flex-end;
        align-items: baseline;
      }
      .topRight {
        right: ${({ gridCheck }) => (gridCheck ? '28px' : '36px')};
        top: 118px;
        position: absolute;
        z-index: 1400;
      }
    }

    .leaflet-control-zoom {
      margin: 64px 6px;
    }

    .container-horizontal-grid {
      .horizontal-grid {
        margin-top: 2px;
        margin-left: 70px;
        margin-right: 17px;
      }
    }
  }
  /**
  * ============Predefiniçoes===================
  */
  .distanceBox1 {
    margin-top: 10px;
  }

  .size {
    display: inline-flex;
    margin-top: 14px;
  }

  .selectSize {
    width: 79px;
    height: 40px;
    border: 0.5px solid rgba(0, 0, 0, 0.33);
    border-radius: 3px;
  }

  .orientation {
    margin-left: 24px;
  }

  .selectOrientation {
    width: 142px;
    height: 40px;
    border: 0.5px solid rgba(0, 0, 0, 0.33);
    border-radius: 3px;
  }

  .leiaute {
    margin-left: 31px;
  }

  .iconsLeiaute {
    display: inline-flex;
    margin-top: 15px;
  }

  .iconRetrato {
    margin-left: 15px;
  }
  /**
  * ========Configuração do Arquivo===================
  */
  .distanceBox2 {
    margin-top: 0px;
  }

  input {
    margin-top: 4.3px;
    padding: 12px 0px 12px 12px;
  }

  .marginFields {
    margin-top: 18px;
  }

  .marginCampos input::placeholder {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    color: #ababab;
  }

  .inputText {
    box-sizing: border-box;
    width: 350.6px;
    height: 40px;

    border: 0.5px solid rgba(0, 0, 0, 0.33);
    border-radius: 3px;
  }

  .checkbox {
    display: inline;
    padding: 2px;
    margin-bottom: 2px;
  }

  .checkbox input {
    min-height: 15px;
    min-width: 15px;
  }

  .checkbox label {
    margin-left: 7px;
    padding-right: 18px;
    position: relative;
    font-family: 'Roboto';
    font-size: 15px;
    top: -1.35px;
  }

  .checkbox span {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 16px;
    color: #5e5e5e;
    margin-left: 85px;

    &.warning {
      color: #ff9800;
    }
  }

  .externalSource {
    margin-top: 0px;
  }

  .distanceLabelCheckbox {
    height: 10px;
  }

  /**
  * ======== Legenda ===================
  */
  .divLabelLegend {
    margin-bottom: 8px;
  }

  .divMultiselect label {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
  }

  .fontLegend {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    color: #ababab;

    width: 79px;
    height: 40px;
    border: 0.5px solid rgba(0, 0, 0, 0.33);
    border-radius: 3px;
    margin-top: 15px;
  }

  /**
  * ======== Grade de Coordenadas ===================
  */
  .fuso {
    width: 100px;
    height: 40px;
    border: 0.5px solid rgba(0, 0, 0, 0.33);
    border-radius: 3px;
    margin-left: 18px;

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #ababab;
  }

  #hidden-scale-map {
    .scale {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-align-items: baseline;
      -webkit-box-align: baseline;
      -ms-flex-align: baseline;
      align-items: baseline;

      .value {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        color: #ffffff;
        min-width: 42px;
        margin-right: 3px;
      }

      .line {
        width: 85px;
        height: 5.22px;
        border: 2px solid #ffffff;
        border-top-color: rgb(255, 255, 255);
        border-top-style: solid;
        border-top-width: 2px;
        border-top: none;
      }
    }
  }

  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(37, 37, 37, 0.8);
    color: #5e5e5e;
    z-index: 1700;
    @media (max-width: 768px) {
      height: calc(50vh - 53px);
      top: 60px;
    }
  }  
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  width: 100%;

  &.MuiButton-root {
    text-transform: none;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 16px;
  }

  &.MuiButton-contained {
    color: #fff;
    background: #3c71dd;

    &:hover {
      background: #3463c1;
    }
  }

  &:disabled {
    background: #aeaeae;
  }
`;
